export default __webpack_public_path__ + "static/media/chat-bg.33066faf.png";